// @ts-ignore

import { motion } from 'framer-motion';
import { useEffect, useRef, useState } from 'react';

interface AnimatedListProps {
  items: React.ReactElement[];
}

const AnimatedList = ({ items }: AnimatedListProps) => {
  const listRef = useRef<HTMLUListElement | null>(null);
  const [maxHeight, setMaxHeight] = useState(0);

  useEffect(() => {
    if (listRef.current) {
      setMaxHeight(listRef.current?.scrollHeight);
    } else {
      setMaxHeight(0);
    }
  }, [items]);

  return (
    <motion.div
      initial={{ opacity: 0, maxHeight: 0, overflow: 'hidden' }}
      animate={{ opacity: 1, maxHeight }}
      transition={{ duration: 0.5, ease: 'easeInOut' }}
    >
      <ul
        ref={listRef}
        style={{ overflow: 'hidden', listStyle: 'none', padding: 0 }}
      >
        {items.map((item, index) => (
          <motion.li
            key={index}
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, delay: index * 0.1 }}
          >
            {item}
          </motion.li>
        ))}
      </ul>
    </motion.div>
  );
};

export default AnimatedList;
